import { render, staticRenderFns } from "./headerComponent.vue?vue&type=template&id=f05bff1c&scoped=true&"
import script from "./headerComponent.vue?vue&type=script&lang=js&"
export * from "./headerComponent.vue?vue&type=script&lang=js&"
import style0 from "./headerComponent.vue?vue&type=style&index=0&id=f05bff1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05bff1c",
  null
  
)

export default component.exports